import { render, staticRenderFns } from "./PhotoPayStep.vue?vue&type=template&id=74dad402&scoped=true"
import script from "./PhotoPayStep.vue?vue&type=script&lang=js"
export * from "./PhotoPayStep.vue?vue&type=script&lang=js"
import style0 from "./PhotoPayStep.vue?vue&type=style&index=0&id=74dad402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dad402",
  null
  
)

export default component.exports